import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface AccordionProps {
  emoji: string;
  title: string;
  body: string | string[];
  defaultOpen?: boolean;
}
export function Accordion({
  emoji,
  title,
  body,
  defaultOpen = false
}: AccordionProps) {
  const [open, setOpen] = useState(defaultOpen);
  const items = Array.isArray(body) ? body : [body];
  return <div className="overflow-hidden rounded-xl border border-orange-500/30 bg-neutral-900/80 backdrop-blur-sm" data-id="element-58">
      <button onClick={() => setOpen(v => !v)} aria-expanded={open} className="flex w-full items-center gap-3 px-4 py-4 text-left" data-id="element-59">
        <span className="text-xl leading-none" aria-hidden data-id="element-60">
          {emoji}
        </span>
        <span className="flex-1 text-sm font-bold text-white" data-id="element-61">{title}</span>
        <motion.span animate={{
        rotate: open ? 180 : 0
      }} transition={{
        duration: 0.2
      }} data-id="element-62">
          <ChevronDownIcon className="h-5 w-5 shrink-0 text-orange-400" data-id="element-63" />
        </motion.span>
      </button>
      <AnimatePresence initial={false} data-id="element-64">
        {open && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.25
      }} data-id="element-65">
            <ul className="space-y-2 border-t border-orange-500/20 px-4 py-4 text-sm leading-relaxed text-neutral-300" data-id="element-66">
              {items.map(item => <li key={item} className="flex items-start gap-2" data-id="element-67">
                  {items.length > 1 && <span className="mt-0.5 text-orange-400" aria-hidden data-id="element-68">
                      •
                    </span>}
                  <span data-id="element-69">{item}</span>
                </li>)}
            </ul>
          </motion.div>}
      </AnimatePresence>
    </div>;
}